import { preAuthCode } from "../constant/prefix";
var excludesModule = [];
function authDecorator(authCode, excludeIntercept) {
    return function (target) {
        target[preAuthCode] = authCode;
        if (excludeIntercept) {
            var index = excludesModule.indexOf(target);
            if (index === -1) {
                excludesModule.push(target);
            }
        }
    };
}
function getExcludeModules() {
    return excludesModule;
}
export { authDecorator as auth, getExcludeModules };
